import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import {
  trackPageView,
  startScrollTracking,
  startClickTracking,
  trackExitIntent,
  fetchABVariants,
} from '../lib/engine';

/**
 * Hook that auto-tracks page views, scroll depth, clicks, and exit intent.
 * Drop into App.js — runs once per route change.
 */
export function useConversionEngine() {
  const { pathname } = useLocation();
  const initialized = useRef(false);

  // Initialize A/B variants on first load
  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      fetchABVariants();
    }
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  // Track per page change
  useEffect(() => {
    trackPageView(pathname);

    const cleanupScroll = startScrollTracking(pathname);
    const cleanupClicks = startClickTracking(pathname);
    const cleanupExit = trackExitIntent(pathname);

    return () => {
      if (typeof cleanupScroll === 'function') cleanupScroll();
      if (typeof cleanupClicks === 'function') cleanupClicks();
      if (typeof cleanupExit === 'function') cleanupExit();
    };
  }, [pathname]);  // eslint-disable-line react-hooks/exhaustive-deps
}
